define([
    "jquery",
    "underscore",
    "marionette",
    "holdon"
], function($, _, Marionette) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui:{
            'notificationNoticeCheck': '.notification_notice_check',
            'qualificationValidateButton': '.btn_continue'
        },

        events:{
            'click @ui.qualificationValidateButton': 'checkQualification'
        },

        padding: function( originalStr, padding, length, position) {
            var returnStr = '';
            if( position == 'end')
                returnStr = originalStr;

            for( var i = 0 ; i < length - originalStr.length; i++) {
                returnStr += padding;
            }

            if( position == 'front')
                returnStr += originalStr;

            return returnStr;
        },

        initialize: function(){
            this.bindUIElements();
        },

        checkQualification: function(e){
            if(e) e.preventDefault();

            HoldOn.open({
                theme:"sk-fading-circle"
            });

            var checkedValues = $('.notification_notice_check input:radio');
            var isQualified = checkedValues[0].checked;

            if (isQualified)
            {
                window.location.href = '/open_account/live_account_index/individual';
            }
            else
            {
                window.location.href = '/open_account/live_account_lead';
            }
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/uk/main/js/views/w/open_account/live_account_view.js
// module id = 61
// module chunks = 0